type EligibilityDialogText = {
  button: string
}

type ElibilityConfig = {
  name: string
  code: string
  eligibility_prompt_text: EligibilityDialogText
}
export const ELIGIBILITY_DIALOG_LANGUAGES: ElibilityConfig[] = [
  {
    name: 'English',
    code: 'en-US',
    eligibility_prompt_text: {button: 'Continue'},
  },
  {
    name: 'Español',
    code: 'es-US',
    eligibility_prompt_text: {button: 'Continuar'},
  },
  {
    name: 'Deutsch',
    code: 'de-DE',
    eligibility_prompt_text: {button: 'Weiter'},
  },
  {
    name: 'Français',
    code: 'fr-FR',
    eligibility_prompt_text: {button: 'Continuer'},
  },
  {
    name: 'हिन्दी',
    code: 'hi-IN',
    eligibility_prompt_text: {button: 'आगे बढ़ें'},
  },
  {
    name: 'Português',
    code: 'pt-BR',
    eligibility_prompt_text: {button: 'Continuar'},
  },
  {
    name: 'العربية',
    code: 'ar-XA',
    eligibility_prompt_text: {button: 'متابعة'},
  },
  {
    name: 'Bahasa Indonesia',
    code: 'id-ID',
    eligibility_prompt_text: {button: 'Lanjutkan'},
  },
  {
    name: 'Italiano',
    code: 'it-IT',
    eligibility_prompt_text: {button: 'Continua'},
  },
  {
    name: '日本語',
    code: 'ja-JP',
    eligibility_prompt_text: {button: '次へ'},
  },
  {
    name: 'Türkçe',
    code: 'tr-TR',
    eligibility_prompt_text: {button: 'Devam Et'},
  },
  {
    name: 'Tiếng Việt',
    code: 'vi-VN',
    eligibility_prompt_text: {button: 'Tiếp tục'},
  },
  {
    name: 'বাংলা',
    code: 'bn-IN',
    eligibility_prompt_text: {button: 'এগিয়ে যান'},
  },
  {
    name: 'ગુજરાતી',
    code: 'gu-IN',
    eligibility_prompt_text: {button: 'આગળ વધો'},
  },
  {
    name: 'ಕನ್ನಡ',
    code: 'kn-IN',
    eligibility_prompt_text: {button: 'ಮುಂದುವರಿಸಿ'},
  },
  {
    name: 'മലയാളം',
    code: 'ml-IN',
    eligibility_prompt_text: {button: 'തുടരുക'},
  },
  {
    name: 'मराठी',
    code: 'mr-IN',
    eligibility_prompt_text: {button: 'पुढे चला'},
  },
  {
    name: 'தமிழ்',
    code: 'ta-IN',
    eligibility_prompt_text: {button: 'தொடரவும்'},
  },
  {
    name: 'తెలుగు',
    code: 'te-IN',
    eligibility_prompt_text: {button: 'కొనసాగించు'},
  },
  {
    name: 'Nederlands',
    code: 'nl-NL',
    eligibility_prompt_text: {button: 'Doorgaan'},
  },
  {
    name: '한국어',
    code: 'ko-KR',
    eligibility_prompt_text: {button: '계속하기'},
  },
  {
    name: '官话',
    code: 'cmn-CN',
    eligibility_prompt_text: {button: '继续'},
  },
  {
    name: 'Polski',
    code: 'pl-PL',
    eligibility_prompt_text: {button: 'Dalej'},
  },
  {
    name: 'Русский',
    code: 'ru-RU',
    eligibility_prompt_text: {button: 'Продолжить'},
  },
  {
    name: 'Kiswahili',
    code: 'sw-KE',
    eligibility_prompt_text: {button: 'Endelea'},
  },
  {
    name: 'ไทย',
    code: 'th-TH',
    eligibility_prompt_text: {button: 'ดำเนินการต่อ'},
  },
  {
    name: 'اردو',
    code: 'ur-IN',
    eligibility_prompt_text: {button: 'جاری رکھیں'},
  },
  {
    name: 'Українська',
    code: 'uk-UA',
    eligibility_prompt_text: {button: 'Продовжити'},
  },
]
